export default [
    {
        path: '/leads',
        name: 'CompanyLeads',
        meta: {
            requiresAuth: true,
            companyStatuses: ['VETTED', 'ONBOARDED', 'LEAD_PARTNER_QUALIFIED'],
            title: 'Leads',
        },
        components: {
            default: () => import('@views/leads/CompanyLeads.vue'),
            agent: () => import('@views/leads/CompanyLeads.vue'),
        },
    },
    {
        path: '/leads-management',
        name: 'CompanyLeadManagement',
        meta: {
            requiresAuth: true,
            companyStatuses: ['VETTED', 'ONBOARDED', 'LEAD_PARTNER_QUALIFIED'],
            title: 'Lead region subscriptions',
        },
        components: {
            default: () => import('@views/leads/CompanyLeadManagement.vue'),
            agent: () => import('@views/leads/CompanyLeadManagement.vue'),
        },
    },
    {
        path: '/lead-credit-transactions',
        name: 'CompanyLeadCreditTransactions',
        meta: {
            requiresAuth: true,
            companyStatuses: ['VETTED', 'ONBOARDED', 'LEAD_PARTNER_QUALIFIED'],
            title: 'Credit transactions',
        },
        components: {
            default: () => import('@views/leads/CompanyLeadCreditTransactions.vue'),
            agent: () => import('@views/leads/CompanyLeadCreditTransactions.vue'),
        },
    },
    {
        path: '/lead-subscriptions',
        name: 'CompanyMySubscriptions',
        meta: {
            requiresAuth: true,
            companyStatuses: ['VETTED', 'ONBOARDED', 'LEAD_PARTNER_QUALIFIED'],
            title: 'Subscriptions',
        },
        components: {
            default: () => import('@views/leads/CompanyMySubscriptions.vue'),
            agent: () => import('@views/leads/CompanyMySubscriptions.vue'),
        },
    },
    {
        path: '/leads/:uuid',
        name: 'CompanyLeadDetail',
        meta: {
            requiresAuth: true,
            companyStatuses: ['VETTED', 'ONBOARDED', 'LEAD_PARTNER_QUALIFIED'],
            title: 'Job',
        },
        props: {
            default: (route) => ({ uuid: route.params.uuid }),
            agent: (route) => ({ uuid: route.params.uuid }),
        },
        components: {
            default: () => import('@views/leads/CompanyLeadDetail.vue'),
            agent: () => import('@views/leads/CompanyLeadDetail.vue'),
        },
    },
    {
        path: '/lead-regions/subscribe/success',
        name: 'LeadRegionSubscribeSuccess',
        meta: {
            requiresAuth: true,
            companyStatuses: ['VETTED', 'ONBOARDED', 'LEAD_PARTNER_QUALIFIED'],
            title: 'Subscription success',
        },
        components: {
            default: () => import('@views/leads/subscribe/LeadRegionSubscribeSuccess.vue'),
            agent: () => import('@views/leads/subscribe/LeadRegionSubscribeSuccess.vue'),
        },
    },
    {
        path: '/lead-regions/subscribe/cancel',
        name: 'LeadRegionSubscribeCancel',
        meta: {
            requiresAuth: true,
            companyStatuses: ['VETTED', 'ONBOARDED', 'LEAD_PARTNER_QUALIFIED'],
            title: 'Subscription cancelled',
        },
        components: {
            default: () => import('@views/leads/subscribe/LeadRegionSubscribeCancel.vue'),
            agent: () => import('@views/leads/subscribe/LeadRegionSubscribeCancel.vue'),
        },
    },
    {
        path: '/orders',
        name: 'Leads',
        meta: {
            requiresAuth: true,
            title: 'Your leads',
        },
        components: {
            default: () => import('@views/leads/LeadsIndex.vue'),
            agent: () => import('@views/leads/LeadsIndex.vue'),
        },
    },
    {
        path: '/orders/create',
        name: 'LeadCreate',
        meta: {
            requiresAuth: true,
            title: 'Create lead',
        },
        components: {
            default: () => import('@views/leads/LeadCreate.vue'),
            agent: () => import('@views/leads/LeadCreate.vue'),
        },
    },
];
